<template>
    <div class="editor-box" v-if="isDeleteMode">
        <ul class="editor-select" ref="editor-box-check">
            <li>
                <button type="button"
                        :class="checkedCount > 0 ? 'txt-editor-common txt-active' : 'txt-editor-common txt-detactive'"
                        @click.prevent="deleteSelectedFn" :disabled="checkedCount === 0">선택삭제(<span>{{checkedCount | amount}}</span>)
                </button>
            </li>
            <li>
                <button type="button" class="txt-editor-common txt-all"
                        @click.prevent="deleteAllFn">전체삭제(<span>{{totalCount | amount}}</span>)
                </button>
            </li>
        </ul>
        <ul class="editor-complete">
            <li>
                <button type="button" class="txt-editor-common txt-complete" @click.prevent="changeMode">나가기</button>
            </li>
        </ul>
    </div>
    <div class="editor-box" ref="editor-box" v-else-if="!isDeleteMode">
        <ul class="editor-edit">
            <li>
                <button type="button"
                        class="txt-editor-common txt-editor"
                        @click.prevent="changeMode">편집
                </button>
            </li>
        </ul>
    </div>
</template>
<script>
import { amount } from '@/common/filters'
import utils from '@/common/util/utils'
export default {
  name: 'MyPooqHistoryHeader',
  props: {
    changeMode: { type: Function },
    checkedCount: { type: Number },
    deleteAll: { type: Function },
    deleteSelected: { type: Function },
    isDeleteMode: { type: Boolean },
    totalCount: { type: Number }
  },
  filters: {
    amount
  },
  methods: {
    async deleteAllFn () {
      if (await utils.asyncConfirm(`전체삭제를 진행하시겠습니까? ${this.totalCount}건의 내역이 모두 삭제됩니다.`)) {
        this.deleteAll()
      }
    },
    deleteSelectedFn () {
      this.deleteSelected()
      // if (confirm(`${this.checkedCount}건을 삭제할까요?`)) {
      //   this.deleteSelected()
      // }
    }
  }
}
</script>
<style scoped>
  .txt-deactive {
    color: #888;
  }
</style>
